export const transferSteps = {
  transferStepsBeneficiary: "Beneficiary",
  transferStepsAmount: "Amount",
  transferStepsTransfer: "Transfer",
  transferStepsError: "Transfer failed",
  transferStepsErrorDesc_1: "Your transfer failed, please check your data or contact support.",
  transferStepsSuccess: "Transfer success",
  transferStepsSuccessMessage: "Your transfer has been processed successfully.",
  transferStepsNext: "Next",
  transferStepsConfirm: "Confirm",
  transferStepsBack: "Back",
  transferStepsCancel: "Cancel",

  // Content step 1,
  transferStepsSelectContact: "Select contact",
  transferStepsSelectContactOption: "Select a contact",
  transferSteps_loading: "Loading contacts...",
  transferSteps_loadingError: "Error loading contacts",

  // Content step 2,
  transferStepsTransferAmount: "Enter the amount to transfer",
  transferStepsTransferAmountInput: "Enter amount",
  transferStepsAmountError: "Invalid amount",
  transferStepsAmountError2: "Insufficient balance",

  // Content step 3,
  transferSteps_3_Confirm: "Transfer confirmation",
  transferSteps_3_Beneficiary: "Beneficiary ",
  transferSteps_3_Amount: "Amount",
};
